import React from 'react';
import { Link } from 'react-router-dom';
import { Wallet, Zap, ThumbsUp, Award, ArrowRight, ShieldCheck } from 'lucide-react';
import '../styles/global.css';

const HowToUse = () => {
  return (
    <div className="container" style={{ paddingTop: '100px', paddingBottom: '60px', maxWidth: '1000px', margin: '0 auto' }}>
      
      {/* 1. Header Section */}
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', borderRadius: '20px', background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', fontWeight: 'bold', marginBottom: '20px' }}>
          <ShieldCheck size={18} /> StakeStreet Protocol
        </div>
        <h1 style={{ fontSize: '3rem', marginBottom: '20px', lineHeight: '1.2' }}>
          How to Earn on <span className="text-gradient">StakeStreet</span>
        </h1>
        <p style={{ fontSize: '1.2rem', color: 'var(--text-muted)', maxWidth: '600px', margin: '0 auto' }}>
          Turn your local knowledge into crypto rewards. Follow these simple steps to start staking on infrastructure data.
        </p>
      </div>

      {/* 2. Steps Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '60px' }}>
        
        {/* Step 1 */}
        <StepCard 
          step="01"
          icon={Wallet}
          title="Connect Wallet"
          desc="Link your MetaMask wallet to the Monad Testnet. This is your identity and bank on StakeStreet."
          color="#3b82f6"
        />

        {/* Step 2 */}
        <StepCard 
          step="02"
          icon={Zap}
          title="Stake & Report"
          desc="Spot a hazard? Stake 5 $GUARD tokens to report it. Your stake proves you aren't spamming."
          color="#ef4444"
        />

        {/* Step 3 */}
        <StepCard 
          step="03"
          icon={ThumbsUp}
          title="Community Verify"
          desc="Other citizens upvote your report. If it gets verified, the community validates your truth."
          color="#10b981"
        />

        {/* Step 4 */}
        <StepCard 
          step="04"
          icon={Award}
          title="Earn Rewards"
          desc="Once verified, you get your stake back PLUS a reward (e.g., 15 $GUARD) for keeping roads safe."
          color="#f59e0b"
        />
      </div>

      {/* 3. Call to Action */}
      <div className="glass-panel" style={{ padding: '60px', textAlign: 'center', background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Ready to start earning?</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: '30px', maxWidth: '500px', margin: '0 auto 30px' }}>
          Join thousands of citizens making their cities smarter and safer on the Monad Blockchain.
        </p>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <Link to="/report" className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
            Start Reporting <ArrowRight size={18} />
          </Link>
          <Link to="/wallet" className="glass-btn" style={{ textDecoration: 'none' }}>
            Get Testnet Tokens
          </Link>
        </div>
      </div>

    </div>
  );
};

// Helper Component for consistency
const StepCard = ({ step, icon: Icon, title, desc, color }) => (
  <div className="glass-panel" style={{ padding: '30px', position: 'relative', overflow: 'hidden' }}>
    <div style={{ position: 'absolute', top: '-10px', right: '-10px', fontSize: '4rem', fontWeight: '900', color: 'var(--text-muted)', opacity: 0.1 }}>
      {step}
    </div>
    <div style={{ width: '50px', height: '50px', borderRadius: '12px', background: `${color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
      <Icon size={24} color={color} />
    </div>
    <h3 style={{ fontSize: '1.4rem', marginBottom: '10px' }}>{title}</h3>
    <p style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{desc}</p>
  </div>
);

export default HowToUse;